import { FormattedMessage } from 'react-intl'

import Button from 'app/components/base/Button'
import AddAddressDialog from 'app/features/ListingFeature/components/dialogs/AddAddressDialog'
import useVerifyAuth from 'app/features/ListingFeature/hooks/useVerifyAuth'
import useModal from 'app/hooks/useModal'

interface AddAddressButtonProps {
  calculateShippingCost: (address: Partial<Address>) => Promise<void>
}

const AddAddressButton: RFC<AddAddressButtonProps> = ({
  calculateShippingCost
}) => {
  const { open, hideModal, showModal } = useModal()

  const checkAuth = useVerifyAuth()

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        sx={{ maxWidth: 210, alignSelf: 'flex-start' }}
        onClick={() => checkAuth(showModal)}
      >
        <FormattedMessage defaultMessage="+ Add delivery address" />
      </Button>

      {open && (
        <AddAddressDialog
          open={open}
          onClose={hideModal}
          calculateShippingCost={calculateShippingCost}
        />
      )}
    </>
  )
}

export default AddAddressButton
